import { P2GBox, P2GCardContainer, P2GFade, P2GGrid, P2GText } from '@parcel2go/core-ui';
import Loading from '../progress/loading';
import { ReactNode, Suspense } from 'react';

type BasicSectionProps = {
  children: React.ReactNode;
  dataTestId: string;
  loading?: boolean;
};

type SectionProps = {
  title?: string;
  subTitle?: ReactNode;
} & BasicSectionProps;

export function BasicSection({ children, dataTestId, loading = false }: BasicSectionProps) {
  return (
    <P2GFade in={true} timeout={1000}>
      <P2GBox dataTestId={dataTestId}>{loading ? <Loading /> : <Suspense>{children}</Suspense>}</P2GBox>
    </P2GFade>
  );
}

function Section({ title, children, dataTestId, loading = false, subTitle }: SectionProps) {
  return (
    <P2GFade in={true} timeout={1000}>
      <P2GCardContainer style={{ maxHeight: 'none', overflow: 'visible' }} dataTestId={dataTestId}>
        <P2GGrid container flexDirection="column" sx={{ p: { xs: 1, sm: 2 } }}>
          {title && (
            <P2GGrid item>
              <P2GText
                dataTestId={`${dataTestId}-title`}
                variant="h3"
                component="div"
                mb={3}
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                gap={1}
              >
                {title}
                {subTitle && <span>{subTitle}</span>}
              </P2GText>
            </P2GGrid>
          )}
          {loading ? (
            <Loading />
          ) : (
            <P2GGrid item>
              <Suspense>{children}</Suspense>
            </P2GGrid>
          )}
        </P2GGrid>
      </P2GCardContainer>
    </P2GFade>
  );
}

export default Section;
